import i18n from 'i18next';
import _uniq from 'lodash/uniq';
import React from 'react';

import FormTitleSession from '@/components/FormTitleSession';
import ProposalPartnersAdministration from '@/modules/proposalRequest/components/ProposalPartnersAdministration';
import {
  DIALOG_ADMIN_GENERAL_PARTNER_NAMESPACE,
  DIALOG_CONTROL_GENERAL_PARTNER_NAMESPACE
} from '@/modules/proposalRequest/contants/proposalRequest';

export const organizationsFields = [
  {
    key: 'administration',
    // eslint-disable-next-line react/display-name
    render: () => <FormTitleSession translate={'proposalRequest'} title={'steps.administration'}/>
  },
  {
    key: 'administrationControl',
    widget: ProposalPartnersAdministration,
    widgetProps: {
      canAddRepresentative: true,
      addRepresentativeText: 'proposalRequest.form.organizations.administration.addRepresentativeText',
      dialogContext: DIALOG_ADMIN_GENERAL_PARTNER_NAMESPACE
    },
    rules: [
      {
        validator: (rule, value) => {
          return new Promise((resolve, reject) => {
            const elements = value?.members?.filter(e => !!e);
            const w = elements?.map(e => e?.idNumber);
            const dict = new Set(w);
            if (!elements || !elements?.length)
              return resolve();
            if (_uniq(w).length !== w.length) {
              reject(new Error(i18n.t('proposalRequest:proposalRequest.form.organizations.inspectionControl.verificationMembers')));
            } else {
              const exist = dict.has(value.representative?.idNumber);
              if (exist || dict.size !== elements?.length) {
                reject(new Error(i18n.t('proposalRequest:proposalRequest.form.organizations.inspectionControl.verification')));
              } else {
                resolve();
              }
            }
          });
        }
      },
    ]
  },
  {
    key: 'control',
    // eslint-disable-next-line react/display-name
    render: () => <FormTitleSession translate={'proposalRequest'} title={'steps.control'}/>
  },
  {
    key: 'inspectionControl',
    widget: ProposalPartnersAdministration,
    widgetProps: {
      canAddRepresentative: true,
      addRepresentativeText: 'proposalRequest.form.organizations.administration.addRepresentativeText',
      dialogContext: DIALOG_CONTROL_GENERAL_PARTNER_NAMESPACE
    },
    rules: [
      {
        validator: (rule, value) => {
          return new Promise((resolve, reject) => {
            const elements = value?.members?.filter(e => !!e);
            const w = elements?.map(e => e?.idNumber);
            const dict = new Set(w);
            if (!elements || !elements?.length)
              return resolve();
            if (_uniq(w).length !== w.length) {
              reject(new Error(i18n.t('proposalRequest:proposalRequest.form.organizations.inspectionControl.verificationMembers')));
            } else {
              const exist = dict.has(value.representative?.idNumber);
              if (exist || dict.size !== elements?.length) {
                reject(new Error(i18n.t('proposalRequest:proposalRequest.form.organizations.inspectionControl.verification')));
              } else {
                resolve();
              }
            }
          });
        }
      },
    ]
  },
];
